import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";
import type { salesOrders } from "types/api-types/crm/sales-orders/sales-orders.types";
import type { accounts } from "types/api-types/crm/accounts/accounts.types";
import type { user } from "types/api-types/user/user/user.types";
import type { job } from "types/api-types/job/job/job.types";

const ProjectInitializationWorkflowRoute: RouteType = {
  name: "Project Initialization Workflow",
  path: "/workflows/project-initialization",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Project Initialization",
      component: () => import("./ProjectInitializationWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProjectInitializationWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      const accountsStore = rootStore.accountsStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;

      await Promise.all([
        salesOrdersStore?.find(),
        accountsStore?.find(),
        userStore?.find(),
        jobStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for project initialization:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    // Reset the wizard state when leaving
    const store = (rootStore as any).projectInitializationWorkflowStore;
    store?.reset();
  },
};

export default ProjectInitializationWorkflowRoute;
